<template>
  <div>
    <label :name="systemName + '-label'" :for="systemName" class="block text-black mt-2">
      {{ label }}
    </label>
    <textarea
      :id="systemName"
      :name="systemName"
      :type="type"
      v-bind="$attrs"
      :placeholder="placeholder || label"
      class="w-full h-full px-4 py-3 bg-gray-100 border rounded-sm field focus:outline-none"
      :class="{ 'border-red-800': error, 'resize-none': !allowResize }"
      :value="modelValue"
      :aria-describedby="error ? `${systemName}-error` : ''"
      :aria-invalid="error ? true : false"
      :disabled="disabled"
      @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    />
    <p
      :id="`${systemName}-error`"
      class="text-red-800"
      v-show="error"
      aria-live="assertive"
    >
      {{ error }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { ToSystemName } from "../helpers";

const props = withDefaults(
  defineProps<{
    label?: string;
    modelValue?: string | number;
    error?: string;
    type?: string;
    placeholder?: string;
    disabled?: boolean;
    allowResize?: boolean;
  }>(),
  {
    label: "",
    modelValue: "",
    error: "",
    type: "text",
    placeholder: "",
    disabled: false,
    allowResize: true,
  }
);

const systemName = ToSystemName(props.label);
</script>
